// Chamada chegando com o app aberto: tela de atender ou recusar, por cima de tudo.
import { useEffect, useRef } from 'react';
import { Animated, Platform, Pressable, Text, Vibration, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { pararDeTocar, useChat } from '../lib/chat';
import { abrirChamada } from '../lib/chamada';
import { t } from '../lib/i18n';

export function Tocando() {
  const { tocando } = useChat();
  const ins = useSafeAreaInsets();
  const pulso = useRef(new Animated.Value(1)).current;
  useEffect(() => {
    if (!tocando) return;
    if (Platform.OS !== 'web') Vibration.vibrate([0, 1000, 800], true);
    const anim = Animated.loop(Animated.sequence([
      Animated.timing(pulso, { toValue: 1.12, duration: 600, useNativeDriver: Platform.OS !== 'web' }),
      Animated.timing(pulso, { toValue: 1, duration: 600, useNativeDriver: Platform.OS !== 'web' }),
    ]));
    anim.start();
    const fim = setTimeout(pararDeTocar, 45000);   // ninguém atendeu: para de tocar
    return () => { anim.stop(); clearTimeout(fim); if (Platform.OS !== 'web') Vibration.cancel(); };
  }, [tocando?.chamada]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!tocando) return null;
  const atender = () => { const x = tocando; pararDeTocar(); abrirChamada(x.conversa, x.midia, x.nome); };
  return (
    <View style={{ position: 'absolute', left: 0, right: 0, top: 0, bottom: 0, backgroundColor: 'rgba(11,13,18,0.97)', alignItems: 'center', justifyContent: 'space-between',
      paddingTop: ins.top + 60, paddingBottom: ins.bottom + 50, zIndex: 9999, elevation: 30 }}>
      <View style={{ alignItems: 'center', gap: 10, paddingHorizontal: 24 }}>
        <Animated.View style={{ transform: [{ scale: pulso }], width: 120, height: 120, borderRadius: 60, backgroundColor: '#374151', alignItems: 'center', justifyContent: 'center' }}>
          <Text style={{ color: '#fff', fontSize: 50, fontWeight: '800' }}>{(tocando.de || '?').trim().charAt(0).toUpperCase()}</Text>
        </Animated.View>
        <Text style={{ color: '#fff', fontSize: 24, fontWeight: '800', textAlign: 'center' }} numberOfLines={2}>{tocando.nome}</Text>
        <Text style={{ color: '#9CA3AF', fontSize: 15, textAlign: 'center' }}>
          {tocando.midia === 'audio' ? t('📞 {nome} está ligando (áudio)', { nome: tocando.de }) : t('🎥 {nome} está ligando (vídeo)', { nome: tocando.de })}
        </Text>
      </View>
      <View style={{ flexDirection: 'row', gap: 70 }}>
        <Pressable onPress={pararDeTocar} accessibilityLabel={t('Recusar')} style={{ alignItems: 'center', gap: 8 }}>
          <View style={{ width: 72, height: 72, borderRadius: 36, backgroundColor: '#DC2626', alignItems: 'center', justifyContent: 'center' }}><Text style={{ fontSize: 30 }}>📵</Text></View>
          <Text style={{ color: '#fff' }}>{t('Recusar')}</Text>
        </Pressable>
        <Pressable onPress={atender} accessibilityLabel={t('Atender')} style={{ alignItems: 'center', gap: 8 }}>
          <View style={{ width: 72, height: 72, borderRadius: 36, backgroundColor: '#16A34A', alignItems: 'center', justifyContent: 'center' }}><Text style={{ fontSize: 30 }}>{tocando.midia === 'audio' ? '📞' : '🎥'}</Text></View>
          <Text style={{ color: '#fff' }}>{t('Atender')}</Text>
        </Pressable>
      </View>
    </View>
  );
}
